import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import {
  IBlockNumberSchema,
  ICreateBlockNumberSchema,
} from "../../Schemas/BlockNumber";

export interface BlockNumbersListResponseBody extends IResponseBody {
  data: {
    block_numbers: IBlockNumberSchema;
  };
}

export class BlockNumbersUpdateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(blockNumberId: number) {
    return `/admin/block-numbers/${blockNumberId}/update`;
  }

  async update(
    blockNumberId: number,
    blockNumberCreateBody: ICreateBlockNumberSchema
  ): Promise<BlockNumbersListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(blockNumberId),
        blockNumberCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
